import GameModel from "../../GameModel";
import Grid from "./Grid";
import GridTile from "./GridTile";

export default class VectorField extends GameModel {
    constructor() {
        super();

        /**
         * Tiles that can be mined.
         * @constant
         * @type {GridTile[]}
         */
        this.commonMiningCandidates = [];
        /**
         * Tiles that can be mined.
         * @constant
         * @type {GridTile[]}
         */
        this.priorityMiningCandidates = [];
        /**
         * Tiles that can be mined.
         * @constant
         * @type {GridTile[]}
         */
        this.currencyMiningCandidates = [];
        /**
         * Destination tiles if there's nothing to mine.
         * @constant
         * @type {GridTile[]}
         */
        this.destinationTileCandidates = [];

        /**
         * @type {boolean}
         */
        this.ignoreCommonTiles = false;

        /**
         * @type {boolean}
         */
        this.ignorePremiumTiles = false;

        /**
         * @type {GridTile}
         */
        this.centerTile = null;
        /**
         * @type {number}
         */
        this.vectorFieldNumber = 0;

        /**
         * @type {boolean}
         */
        this.tileHealthNegligible = false;
    }

    /**
     * @returns {boolean}
     */
    isVectorFieldMineTargetsEmpty() {
        return this.commonMiningCandidates.length === 0 && this.currencyMiningCandidates.length === 0 && this.priorityMiningCandidates.length === 0;
    }

    /**
     * @returns {boolean}
     */
    isPriorityTileVisible() {
        if (this.priorityMiningCandidates.length === 0 && this.currencyMiningCandidates.length === 0) {
            return false;
        }

        // Just because the list isn't empty doesn't mean that there are closed priority tiles. 
        return this.isClosedTileInList(this.priorityMiningCandidates) || this.isClosedTileInList(this.currencyMiningCandidates);
    }

    /**
     * @private
     * @param {GridTile[]} tiles 
     * @returns {boolean}
     */
    isClosedTileInList(tiles) {
        for (let i = 0; i < tiles.length; i++) {
            if (!tiles[i].open) {
                return true;
            }
        }
        return false;
    }

    /**
     * 
     * @param {Grid} grid 
     * @returns {boolean} True if the full vector field has been reset.
     */
    onGridUnload(grid) {
        if (this.centerTile && this.centerTile.grid === grid) {
            this.reset();
            return true;
        }

        this.removeTilesForGrid(grid, this.commonMiningCandidates);
        this.removeTilesForGrid(grid, this.priorityMiningCandidates);
        this.removeTilesForGrid(grid, this.currencyMiningCandidates);

        return false;
    }

    /**
     * @private
     * @param {Grid} grid 
     * @param {GridTile[]} tiles 
     */
    removeTilesForGrid(grid, tiles) {
        for (let i = tiles.length - 1; i >= 0; i--) {
            if (tiles[i].grid === grid) {
                tiles.splice(i, 1);
            }
        }
    }
    
    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.reset();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.reset();
    }

    reset() {
        if (this.commonMiningCandidates.length > 0) {
            this.commonMiningCandidates.length = 0;
        }
        if (this.priorityMiningCandidates.length > 0) {
            this.priorityMiningCandidates.length = 0;
        }
        if (this.currencyMiningCandidates.length > 0) {
            this.currencyMiningCandidates.length = 0;
        }

        this.centerTile = null;
        this.vectorFieldNumber++;

        if (this.vectorFieldNumber > 100000) {
            this.vectorFieldNumber = 0;
        }
    }

}